module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II3.bb842399.png";